export default __webpack_public_path__ + "assets/instant-apps-blog.jpg";